module.exports = __webpack_public_path__ + "img/Smart-Rooms.c984214f.svg";